export { default } from './NoFaresBehavior';
